export enum RemoveReasonType {
  None = 0,
  Scheduled = 1,
  Unscheduled = 2,
  Return_Unused = 3,
}

export const GetRemoveReasonType = [
  // { Description: "None", Value: RemoveReasonType.None },
  { Description: "Scheduled", Value: RemoveReasonType.Scheduled },
  { Description: "Unscheduled", Value: RemoveReasonType.Unscheduled },
  { Description: "Return Unused", Value: RemoveReasonType.Return_Unused },
];
